<script>
  import Opcional from "./Opcional.svelte"
  export let documento
</script>

<div>
  <Opcional {documento} />
</div>
